import { createContext, useContext } from 'react';
import invariant from 'invariant';

import type React from 'react';

export interface ICalendarConfig {
	api?: string;
	dateStart?: string;
	dateEnd?: string;
	instanceId?: string;
}

const CalendarConfigContext = createContext<ICalendarConfig | undefined>(undefined);

export const CalendarConfigProvider: React.FC<{
	children: React.ReactNode;
	value: ICalendarConfig;
}> = ({ children, value }) => {
	return <CalendarConfigContext.Provider value={value}>{children}</CalendarConfigContext.Provider>;
};

export const useCalendarConfig = () => {
	const state = useContext(CalendarConfigContext);

	invariant(state, 'useCalendarConfig must be used within a CalendarConfigProvider');

	return state;
};
